module.exports = require((__resourceQuery.substr(1) + "/resourceQuery/returnRQ?XXXQuery").replace(/XXX/g, "resource"));


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/evaluate/resourceQuery?C:/Users/kop/Repos/webpack/test/cases/parsing/evaluate
 ** module id = 2
 ** module chunks = 0
 **/